import {
    FormControl,
    IterateOptions
} from '../../../../components/FormUtilities'
import InputField from '../../../../components/InputField'
import SelectTouch from '../../../../components/SelectTouch'
import SelectMultiple from '../../../../components/SelectMultiple'
import DropImage from '../../../../components/DropImage'
import Upload from '../../../../components/Upload'
import { formInformation } from '../../storage'

interface ProductOption {
    id: number
    name: string
}

interface CountryOption extends ProductOption {
    code: string
}
function SortDescription() {
    const { props, getError } = formInformation.useInput('name')
    const helper = getError(
        'ERROR-0000107',
        'Ya existe un producto con el mismo nombre'
    )

    return (
        <FormControl label="Descripción corta" required>
            <InputField
                {...props}
                placeholder="Ingresar descripción corta"
                autoFocus
                helper={helper || props.helper}
                regex={null}
            />
        </FormControl>
    )
}

function ManufacturerCode() {
    const { props } = formInformation.useInput('manufacturer_code')
    return (
        <FormControl label="Código Fabricante" required>
            <InputField
                {...props}
                placeholder="Ingresar código fabricante"
                maxLength={255}
            />
        </FormControl>
    )
}

function MeasurementRange() {
    const { props } = formInformation.useInput('measurement_range')
    return (
        <FormControl label="Rango de Medición">
            <InputField
                {...props}
                placeholder="Ingresar rango de medición"
                maxLength={255}
            />
        </FormControl>
    )
}

function Model() {
    const { props } = formInformation.useInput('model')
    return (
        <FormControl label="Modelo">
            <InputField
                {...props}
                placeholder="Ingresar modelo"
                maxLength={255}
            />
        </FormControl>
    )
}

function BrandSelect() {
    const { props, data } = formInformation.useSelect<any>(
        'brand',
        '/v5.6/apis/product_options/brands'
    )
    return (
        <FormControl label="Marca" required>
            <SelectTouch
                {...props}
                placeholder="Seleccionar marca"
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

function CountryAvailability() {
    const { props, data } = formInformation.useSelects<CountryOption>(
        'country_availability',
        '/v5.6/apis/product_options/countries'
    )
    return (
        <FormControl label="Disponibilidad País">
            <SelectMultiple
                {...props}
                placeholder="Seleccionar país(es)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

function ImpactEcosystem() {
    const { props, data } = formInformation.useSelects<ProductOption>(
        'impact_ecosystem',
        '/v5.6/apis/product_options/impact_ecosystems'
    )
    const resolvedOptions = (props.options || []).map(opt => {
        const found = data.find(
            item => item.id.toString() === String(opt.value)
        )
        return found ? { label: found.name, value: opt.value } : opt
    })
    return (
        <FormControl label="Ecosistema de Impacto">
            <SelectMultiple
                {...props}
                options={resolvedOptions}
                placeholder="Seleccionar ecosistema(s)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

function ProductiveProcess() {
    const { props, data } = formInformation.useSelects<ProductOption>(
        'productive_process',
        '/v5.6/apis/product_options/productive_processes'
    )
    const resolvedOptions = (props.options || []).map(opt => {
        const found = data.find(
            item => item.id.toString() === String(opt.value)
        )
        return found ? { label: found.name, value: opt.value } : opt
    })
    return (
        <FormControl label="Proceso Productivo">
            <SelectMultiple
                {...props}
                options={resolvedOptions}
                placeholder="Seleccionar proceso(s) productivo(s)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

function VerticalMarket() {
    const { props, data } = formInformation.useSelects<ProductOption>(
        'vertical_market',
        '/v5.6/apis/product_options/vertical_markets'
    )
    const resolvedOptions = (props.options || []).map(opt => {
        const found = data.find(
            item => item.id.toString() === String(opt.value)
        )
        return found ? { label: found.name, value: opt.value } : opt
    })
    return (
        <FormControl label="Mercado Vertical">
            <SelectMultiple
                {...props}
                options={resolvedOptions}
                placeholder="Seleccionar mercado(s) vertical(es)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

function isCountrySelected(countryId: number) {
    const availability = formInformation.store().country_availability || []
    return availability.some(c => parseInt(String(c.value), 10) === countryId)
}

function FiscalCodeNI() {
    const { props } = formInformation.useInput('fiscal_code_ni')
    const enabled = isCountrySelected(1)
    return (
        <FormControl label="Código Fiscal NI">
            <InputField
                {...props}
                placeholder="Ingresar código fiscal NI"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function FiscalCodeCR() {
    const { props } = formInformation.useInput('fiscal_code_cr')
    const enabled = isCountrySelected(2)
    return (
        <FormControl label="Código Fiscal CR" required={enabled}>
            <InputField
                {...props}
                placeholder="Ingresar código fiscal CR"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function FiscalCodePA() {
    const { props } = formInformation.useInput('fiscal_code_pa')
    const enabled = isCountrySelected(3)
    return (
        <FormControl label="Código Fiscal PA" required={enabled}>
            <InputField
                {...props}
                placeholder="Ingresar código fiscal PA"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function FiscalCodeVE() {
    const { props } = formInformation.useInput('fiscal_code_ve')
    const enabled = isCountrySelected(4)
    return (
        <FormControl label="Código Fiscal VE">
            <InputField
                {...props}
                placeholder="Ingresar código fiscal VE"
                maxLength={255}
                disabled={!enabled}
            />
        </FormControl>
    )
}

function Photo() {
    const { props, getError } = formInformation.useImage('photo')
    const helper = getError()
    return (
        <FormControl label="Foto">
            <DropImage {...props} helper={helper || props.helper} />
        </FormControl>
    )
}

function Literature() {
    const { props } = formInformation.useUploads('literature')
    return (
        <FormControl label="Literatura" col="span-6" row="span-3">
            <Upload {...props} extensions={['pdf', 'doc', 'docx']} />
        </FormControl>
    )
}

function Services() {
    const { props, data } = formInformation.useSelects<ProductOption>(
        'services',
        '/v5.6/apis/product_options/services'
    )
    const resolvedOptions = (props.options || []).map(opt => {
        const found = data.find(
            item => item.id.toString() === String(opt.value)
        )
        return found ? { label: found.name, value: opt.value } : opt
    })

    return (
        <FormControl label="Servicios">
            <SelectMultiple
                {...props}
                options={resolvedOptions}
                placeholder="Seleccionar servicio(s)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

function Certification() {
    const typeProductValue = formInformation.store().type_product?.value
    const { props, data } = formInformation.useSelects<ProductOption>(
        'certification',
        typeProductValue !== undefined
            ? `/v5.6/apis/product_options/certifications?type_product=${typeProductValue}`
            : '/v5.6/apis/product_options/certifications'
    )
    const resolvedOptions = (props.options || []).map(opt => {
        const found = data.find(
            item => item.id.toString() === String(opt.value)
        )
        return found ? { label: found.name, value: opt.value } : opt
    })

    return (
        <FormControl label="Certificación">
            <SelectMultiple
                {...props}
                options={resolvedOptions}
                placeholder="Seleccionar certificación(es)"
                selectTouchInherit={true}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={data} label="name" />
            </SelectMultiple>
        </FormControl>
    )
}

export default function Fields() {
    return (
        <>
            <SortDescription />
            <ManufacturerCode />
            <MeasurementRange />
            <Model />
            <BrandSelect />
            <CountryAvailability />
            <ImpactEcosystem />
            <ProductiveProcess />
            <VerticalMarket />
            <FiscalCodeNI />
            <FiscalCodeCR />
            <FiscalCodePA />
            <FiscalCodeVE />
            <Photo />
            <Services />
            <Certification />
            <Literature />
        </>
    )
}
